import React from "react";
import { useApp } from "../../context/AppContext";
import LegalLayout, { LegalSection } from "./LegalLayout";
import { L } from "../../components/marketing/MarketingChrome";

export default function Terms() {
  const { lang } = useApp();
  return (
    <LegalLayout testid="terms-page" path="/terms"
      seoDescription={L(lang, "Les conditions regissant votre abonnement et votre utilisation de Cockpit OS.", "The terms governing your subscription to and use of Cockpit OS.")}
      title={L(lang, "Conditions Générales de Vente (CGV)", "Terms of Sale")}
      updated={L(lang, "[date]", "[date]")}>

      <p className="text-slate-500">
        {L(lang,
          "Les présentes conditions régissent la souscription et l'utilisation de Cockpit OS. Ce modèle doit être revu par un conseil juridique avant publication.",
          "These terms govern the subscription to and use of Cockpit OS. This template should be reviewed by legal counsel before publishing.")}
      </p>

      <LegalSection heading={L(lang, "1. Éditeur", "1. Provider")}>
        <p>{L(lang,
          "Le service est édité par [Nom légal de la société], [adresse], [SIRET / numéro d'immatriculation]. Contact : [email de contact].",
          "The service is provided by [Company legal name], [address], [company number / VAT]. Contact: [contact email].")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "2. Service", "2. The service")}>
        <p>{L(lang,
          "Cockpit OS est un logiciel en ligne (SaaS) de pilotage d'activité : tâches, projets, CRM, finances, actifs, documents et conseil assisté par IA. Le service est fourni « en l'état » et évolue régulièrement.",
          "Cockpit OS is an online software (SaaS) for running your business: tasks, projects, CRM, finances, assets, documents and AI-assisted advisory. The service is provided 'as is' and evolves regularly.")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "3. Abonnements et prix", "3. Subscriptions and pricing")}>
        <ul className="list-disc pl-5 space-y-1">
          <li>{L(lang, "Les plans, limites et prix sont indiqués sur la page Tarifs. Prix en euros, hors taxes applicables.", "Plans, limits and pricing are shown on the Pricing page. Prices in euros, excluding applicable taxes.")}</li>
          <li>{L(lang, "Facturation mensuelle, annuelle ou à vie, par espace de travail. Chaque plan inclut un nombre fixe de collaborateurs ; pour en ajouter, passez au plan supérieur. Les lecteurs sont gratuits.", "Monthly, annual or lifetime billing, per workspace. Each plan includes a fixed number of collaborators; to add more, upgrade to a higher plan. Viewers are free.")}</li>
          <li>{L(lang, "Le paiement est traité par notre prestataire de paiement. Aucune coordonnée bancaire complète n'est stockée par nos soins.", "Payment is processed by our payment provider. We do not store full card details.")}</li>
        </ul>
      </LegalSection>

      <LegalSection heading={L(lang, "4. Reconduction et résiliation", "4. Renewal and cancellation")}>
        <p>{L(lang,
          "Les abonnements se renouvellent automatiquement à la fin de chaque période, sauf résiliation avant l'échéance. Vous pouvez résilier à tout moment depuis votre espace ; l'accès reste actif jusqu'à la fin de la période payée.",
          "Subscriptions renew automatically at the end of each period unless cancelled before renewal. You may cancel anytime from your account; access remains active until the end of the paid period.")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "5. Droit de rétractation", "5. Right of withdrawal")}>
        <p>{L(lang,
          "Pour les professionnels, le droit de rétractation peut ne pas s'appliquer. Les conditions applicables aux consommateurs seront précisées par [Nom légal de la société].",
          "For professional customers, the right of withdrawal may not apply. Consumer-specific conditions will be specified by [Company legal name].")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "6. Obligations de l'utilisateur", "6. User obligations")}>
        <p>{L(lang,
          "Vous êtes responsable de l'exactitude des données saisies, de la confidentialité de vos identifiants et d'un usage licite du service. Le contenu que vous créez vous appartient.",
          "You are responsible for the accuracy of the data you enter, the confidentiality of your credentials and lawful use of the service. The content you create belongs to you.")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "7. Disponibilité et responsabilité", "7. Availability and liability")}>
        <p>{L(lang,
          "Nous mettons en œuvre des moyens raisonnables pour assurer la disponibilité du service mais ne garantissons pas une disponibilité ininterrompue. Notre responsabilité est limitée dans les conditions prévues par la loi applicable. Les analyses du Conseil IA sont des aides à la décision et ne constituent pas un conseil professionnel.",
          "We use reasonable efforts to keep the service available but do not guarantee uninterrupted availability. Our liability is limited as permitted by applicable law. AI Advisory insights are decision support and do not constitute professional advice.")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "8. Données personnelles", "8. Personal data")}>
        <p>{L(lang,
          "Le traitement des données personnelles est décrit dans notre Politique de confidentialité (RGPD). Vous pouvez exporter ou supprimer vos données à tout moment depuis Réglages.",
          "Personal data processing is described in our Privacy Policy (GDPR). You can export or delete your data anytime from Settings.")}</p>
      </LegalSection>

      <LegalSection heading={L(lang, "9. Droit applicable", "9. Governing law")}>
        <p>{L(lang,
          "Les présentes conditions sont régies par le droit [pays/juridiction]. Tout litige sera soumis aux tribunaux compétents de [ressort].",
          "These terms are governed by the law of [country/jurisdiction]. Any dispute will be submitted to the competent courts of [venue].")}</p>
      </LegalSection>
    </LegalLayout>
  );
}
